import React from "react"
import { FaLinkedinIn } from "@react-icons/all-files/fa/FaLinkedinIn"
import { FaInstagram } from "@react-icons/all-files/fa/FaInstagram"
import { FaFacebookF } from "@react-icons/all-files/fa/FaFacebookF"
import { FaTwitter } from "@react-icons/all-files/fa/FaTwitter"
import { FaYoutube } from "@react-icons/all-files/fa/FaYoutube"

export const mainMenuItems = [
  {
    path: "/blogs",
    title: "blogs",
  },
  {
    path:"/refund-policy/",
    title: "refund policy"
  },
  {
    path:"/terms-conditions/",
    title: "terms & conditions"
  },
  {
    path:"/security-information/",
    title: "security information"
  },
  {
    path:"/disclaimer/",
    title: "disclaimer"
  }

]

export const socialMenuItems = [
  {
    icon: <FaLinkedinIn />,
    url: "https://www.linkedin.com/company/certisured/",
    name: "LinkedIn",
  },
  {
    icon: <FaInstagram />,
    url: "http://www.instagram.com/certisured",
    name: "Instagram",
  },
  {
    icon: <FaFacebookF />,
    url: "https://www.facebook.com/certifiedforsure",
    name: "Facebook",
  },
  {
    icon: <FaYoutube />,
    url: "https://www.youtube.com/channel/UC0_qZH4XvMYMRp9dmta4RFw",
    name: "Youtube",
  },
  {
    icon: <FaTwitter />,
    url: "http://www.twitter.com/certisured",
    name: "Instagram",
  },
]

export const footerMenuItems = [
  {
    path: "https://certisured.com/cair/",
    title: "Certified AI Researcher",
  },
  {
    path: "https://certisured.com/boot-camp-ethical-hacking/",
    title: "Boot camp Ethical Hacking",
  },
  {
    path: "https://certisured.com/webinar-career-planning-cyber-security/",
    title: "Webinar career planning cyber-security",
  },
  {
    path: "/training/diploma-in-machine-learning",
    title: "Diploma in Machine Learning",
  },
  {
    path: "/training/android-penetration-testing",
    title: "Android penetration testing",
  },
  {
    path: "/training/cloud-security-practitioner",
    title: "Cloud security practitioner",
  },
  {
    path: "/training/web-application-penetration-testing",
    title: "Web application penetration testing",
  },
]
